module.exports = __webpack_public_path__ + "img/kz.740ef4bf.svg";